export function cn(...classes: (string | false | null | undefined)[]): string {
  return classes.filter(Boolean).join(" ");
}

export function isInAppBrowser(): boolean {
  if (typeof window === "undefined") return false;
  return window.navigator.userAgent.includes("CROSSx");
}
